export default "__VITE_ASSET__488f478f__"